import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/student-comments";

export default createStore({ Model });
